import styled, { css } from 'styled-components'
import { Close as CloseIcon } from '@styled-icons/evil/Close'

type MenuFullProps = {
  isOpen: boolean
}

type IProps = {
  reduzirNomeUsuario?: boolean
}

const userModifiers = {
  reduzir: () => css`
    max-width: 300px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `
}

export const MenuFull = styled.div<MenuFullProps>`
  ${({ theme, isOpen }) => css`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: ${theme.spacings.large};
    position: fixed;
    z-index: 1;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100vh;
    overflow: hidden;
    background: ${theme.colors.white};
    transition: opacity 0.3s ease-in-out;
    opacity: ${isOpen ? 1 : 0};
    pointer-events: ${isOpen ? 'all' : 'none'};
    padding: ${theme.spacings.medium};
  `}
`

export const HeaderMenu = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`
export const CloseMenu = styled(CloseIcon)`
  ${({ theme }) => css`
    width: 38px;
    position: absolute;
    right: 0;
    color: ${theme.colors.newPrimary};
  `}
`
export const UserMenuContainer = styled.section`
  ${({ theme }) => css`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-bottom: 0.5px solid #cecece;
    padding-bottom: ${theme.spacings.xsmall};
  `}
`

export const UserIcon = styled.div`
  ${({ theme }) => css`
    margin-right: ${theme.spacings.xsmall};
  `}
`
export const UserInfoContent = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    a {
      font-family: 'Gill Sans' !important;
      font-size: ${theme.font.sizes.small};
      text-decoration: none;
      color: #8d8d8d;
    }
  `}
`

export const UserInfo = styled.div<IProps>`
  ${({ theme, reduzirNomeUsuario }) => css`
    width: 100%;
    display: flex;
    align-items: flex-start;

    p {
      font-family: 'Gill Sans' !important;
      font-size: ${theme.font.sizes.xlarge};
      color: ${theme.colors.black};
      margin: 0;
      ${reduzirNomeUsuario && userModifiers.reduzir()};
    }

    strong {
      font-family: 'Gill Sans' !important;
      font-weight: ${theme.font.bold};
      font-size: ${theme.font.sizes.xlarge};
      color: ${theme.colors.primary};
      margin: 0;
      margin-left: 2px;
    }
  `}
`

export const NavContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: ${theme.spacings.xsmall};

    a,
    span {
      font-family: 'Gill Sans' !important;
      font-size: ${theme.font.sizes.medium};
      text-decoration: none;
      color: #343434;
    }
  `}
`

export const ExitContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: center;
    margin-top: auto;

    span {
      font-family: 'Gill Sans' !important;
      font-size: ${theme.font.sizes.xlarge};
      font-weight: ${theme.font.bold};
      color: ${theme.colors.newPrimary};
    }
  `}
`
